var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.8 18h3M14.8 15h3M3 12h18M21 18.652A2.348 2.348 0 0118.652 21H5.348A2.348 2.348 0 013 18.652V5.348A2.348 2.348 0 015.348 3h13.304A2.348 2.348 0 0121 5.348v13.304zM15 7.5h3M6 7.5h3M7.5 9V6M6.44 15.44l2.12 2.12M6.44 17.56l2.12-2.12M12 3v18"
  }))));
}

export default SvgCalculator;


//////////////////
// WEBPACK FOOTER
// ./src/icons/calculator.svg
// module id = 890
// module chunks = 101